var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeMiterlimit: 16,
  strokeWidth: 1.5,
  d: "M11.189 2.232c-.374-1.152-2.004-1.152-2.378 0L7.21 7.16H2.028c-1.21 0-1.714 1.55-.734 2.261l4.192 3.046-1.602 4.928c-.374 1.152.944 2.11 1.924 1.397L10 15.747l4.192 3.045c.98.712 2.298-.245 1.924-1.397l-1.602-4.928 4.192-3.046c.98-.712.477-2.261-.734-2.261H12.79zm3.27 10.062Z"
})));
export default SvgStarOutline;